var _polygon, _rect, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _rect2, _rect3, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPB7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.7.1",
    points: "269 373 361 373 361 383 387 383 387 518 269 518 269 373"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.7.2",
    x: 83.37,
    y: 373,
    width: 180.71,
    height: 157
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.7.3",
    points: "95 204 264 204 264 332 166 332 166 368 95 368 95 204"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.7.4",
    points: "269 193 387 193 387 332 294.95 332 294.95 322 269 322 269 193"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.7.5",
    points: "392 205 510 205 510 322 485 322 485 332 392 332 392 205"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.7.6",
    points: "515 205 633 205 633 332 540.6 332 540.6 322 515 322 515 205"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.7.7",
    points: "638 175 756 175 756 322 731 322 731 332 638 332 638 175"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.7.8",
    points: "761.02 175 893 175 893 305 881 305 881 368 761 368 761.02 175"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.7.9",
    x: 733,
    y: 373,
    width: 148,
    height: 128
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.7.10",
    x: 637.91,
    y: 373,
    width: 90.09,
    height: 127
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.7.11",
    points: "540.5 373 633 373 633 501 515 501 515 383.19 541 383.19 540.5 373"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmlld0JveD0iMCAwIDk5MCA3MjAiPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjcuMSIgcG9pbnRzPSIyNjkgMzczIDM2MSAzNzMgMzYxIDM4MyAzODcgMzgzIDM4NyA1MTggMjY5IDUxOCAyNjkgMzczIi8+CgoKICAgIDxyZWN0IGRhdGEtaWQ9IkIuNy4yIiB4PSI4My4zNyIgeT0iMzczIiB3aWR0aD0iMTgwLjcxIiBoZWlnaHQ9IjE1NyIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjcuMyIgcG9pbnRzPSI5NSAyMDQgMjY0IDIwNCAyNjQgMzMyIDE2NiAzMzIgMTY2IDM2OCA5NSAzNjggOTUgMjA0Ii8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuNy40IiBwb2ludHM9IjI2OSAxOTMgMzg3IDE5MyAzODcgMzMyIDI5NC45NSAzMzIgMjk0Ljk1IDMyMiAyNjkgMzIyIDI2OSAxOTMiLz4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi43LjUiIHBvaW50cz0iMzkyIDIwNSA1MTAgMjA1IDUxMCAzMjIgNDg1IDMyMiA0ODUgMzMyIDM5MiAzMzIgMzkyIDIwNSIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjcuNiIgcG9pbnRzPSI1MTUgMjA1IDYzMyAyMDUgNjMzIDMzMiA1NDAuNiAzMzIgNTQwLjYgMzIyIDUxNSAzMjIgNTE1IDIwNSIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjcuNyIgcG9pbnRzPSI2MzggMTc1IDc1NiAxNzUgNzU2IDMyMiA3MzEgMzIyIDczMSAzMzIgNjM4IDMzMiA2MzggMTc1Ii8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuNy44IiBwb2ludHM9Ijc2MS4wMiAxNzUgODkzIDE3NSA4OTMgMzA1IDg4MSAzMDUgODgxIDM2OCA3NjEgMzY4IDc2MS4wMiAxNzUiLz4KCgogICAgPHJlY3QgZGF0YS1pZD0iQi43LjkiIHg9IjczMyIgeT0iMzczIiB3aWR0aD0iMTQ4IiBoZWlnaHQ9IjEyOCIvPgoKCiAgICA8cmVjdCBkYXRhLWlkPSJCLjcuMTAiIHg9IjYzNy45MSIgeT0iMzczIiB3aWR0aD0iOTAuMDkiIGhlaWdodD0iMTI3Ii8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuNy4xMSIgcG9pbnRzPSI1NDAuNSAzNzMgNjMzIDM3MyA2MzMgNTAxIDUxNSA1MDEgNTE1IDM4My4xOSA1NDEgMzgzLjE5IDU0MC41IDM3MyIvPgoKPC9zdmc+";
export { SvgPB7 as ReactComponent };